import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { formatDate } from "../utils/dateUtils";
import CouponSupportType from "./CouponSupportType";

export default function HomeCoupon({ coupons }) {
  return (
    <Box>
      <Grid container spacing={4}>
        {coupons.map((coupon, id) => (
          <Grid item md={6} key={id} sm={6} xs={12}>
            <Box className="home-coupon-wrapper">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item md={"auto"}>
                  <Typography className="home-coupon-number">
                    クーポンコード: {coupon.couponCode}
                  </Typography>
                </Grid>
                {coupon.expire && (
                  <Grid item md={"auto"} className="home-coupon-expiry">
                    有効期限: {formatDate(coupon.expire, false, "")}
                  </Grid>
                )}
              </Grid>
              <Box>
                <div className="available-names">
                  <CouponSupportType coupon={coupon} />
                </div>
                <Typography
                  component={"h5"}
                  variant="h5"
                  className="classification-heading"
                >
                  {coupon.couponName}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
